module.exports = __webpack_public_path__ + "static/media/exercise_pic.32464636.jpg";